import React, { useState } from "react";
import { Card, CardContent } from "@mui/material";
import { dashboardApi } from "../../Services/Services";
import { useEffect } from "react";
import { Button } from "@mui/material"; // MUI Button
import { FaFilePdf } from "react-icons/fa"; // PDF Icon
import { useNavigate } from "react-router-dom";

export default function DashboardHome() {
  // Party Table ke liye
  const [partySearchDO, setPartySearchDO] = useState("");
  const [partySearchName, setPartySearchName] = useState("");
  // Lifter Table ke liye
  const [lifterSearchDO, setLifterSearchDO] = useState("");
  const [lifterSearchName, setLifterSearchName] = useState("");
  const [lifterData, setLifterData] = useState([]);
  const [clientData, setClientData] = useState([]);
  const [cardDetails, setCardDetails] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    DashboardApiList();
  }, []);

  const DashboardApiList = async () => {
    const response = await dashboardApi({
      company_name: localStorage.getItem("com_name"),
    });
    if (response) {
      if (localStorage.getItem("user_type") === "Lifter") {
        setLifterData(response.lifter_pending_do);
        setCardDetails(response.card_details);
      } else {
        setLifterData(response.lifter_pending_do);
        setClientData(response.client_pending_do);
        setCardDetails(response.card_details);
      }
    }
  };
  const cardsDataLifetr = [
    { title: "Total Do", value: cardDetails.total_do, bg: "#e0f7fa" },
    { title: "Complete Do", value: cardDetails.complete_do, bg: "#fff9c4" },
    { title: "Pending Do", value: cardDetails.pending_do, bg: "#ffe0b2" },
    { title: "Sale Do", value: cardDetails.sale_do, bg: "#c8e6c9" },
    { title: "Leps Do", value: cardDetails.leps_do, bg: "#ffe0b2" },
  ];

  const cardsData = [
    {
      title: "Total Do",
      value: cardDetails.total_do,
      bg: "#e0f7fa",
      link: "/reports-view?report=do_status",
    },
    {
      title: "Complete Do",
      value: cardDetails.complete_do,
      bg: "#fff9c4",
      link: "/reports-view?report=do_status",
    },
    {
      title: "Pending Do",
      value: cardDetails.pending_do,
      bg: "#ffe0b2",
      link: "/reports-view?report=do_status",
    },
    {
      title: "Sale Do",
      value: cardDetails.sale_do,
      bg: "#c8e6c9",
      link: "/reports-view?report=sale_do",
    },
    {
      title: "Leps Do",
      value: cardDetails.leps_do,
      bg: "#ffe0b2",
      link: "/reports-view?report=leps_do",
    },
    {
      title: "Client",
      value: cardDetails.party_count,
      bg: "#e0f7fa",
      link: "/addclients",
    },
    {
      title: "Lifter",
      value: cardDetails.count_lifter,
      bg: "#fff9c4",
      link: "/lifter-assign-view",
    },
    {
      title: "Staff",
      value: cardDetails.staff_count,
      bg: "#ffe0b2",
      link: "/staff-user",
    },
    {
      title: "Not Application Freight",
      value: cardDetails.freight_not_applicable,
      bg: "#c8e6c9",
      link: "/reports-view?report=FreightNotApplicableList",
    },
    {
      title: "Due Payments",
      value: cardDetails.pending_payment,
      bg: "#ffe0b2",
      link: "/freight-pay",
    },
  ];

  const handleMouseMove = (e) => {
    const card = e.currentTarget;
    const rect = card.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    const centerX = rect.width / 2;
    const centerY = rect.height / 2;
    const rotateX = ((y - centerY) / centerY) * 10;
    const rotateY = ((x - centerX) / centerX) * 10;
    card.style.transform = `perspective(1000px) rotateX(${-rotateX}deg) rotateY(${rotateY}deg) scale(1.05)`;
    card.style.boxShadow = `${-rotateY * 2}px ${
      rotateX * 2
    }px 20px rgba(0,0,0,0.5)`;
  };

  const handleMouseLeave = (e) => {
    const card = e.currentTarget;
    card.style.transform =
      "perspective(1000px) rotateX(0deg) rotateY(0deg) scale(1)";
    card.style.boxShadow = "0 10px 20px rgba(0,0,0,0.3)";
  };

  // Party Table filter
  const filteredClientData = clientData.filter((row) => {
    const partyMatch = row.client_name
      .toLowerCase()
      .includes(partySearchName.toLowerCase());

    const doMatch = row.client_pending_do.some((doItem) =>
      doItem.do_no.toLowerCase().includes(partySearchDO.toLowerCase())
    );

    return partyMatch && (partySearchDO ? doMatch : true);
  });

  // Lifter Table filter
  const filteredLifterData = lifterData.filter((row) => {
    const lifterMatch = row.name
      .toLowerCase()
      .includes(lifterSearchName.toLowerCase());

    const doMatch = row.lifter_pending_dos.some((doItem) =>
      doItem.do_no.toLowerCase().includes(lifterSearchDO.toLowerCase())
    );

    return lifterMatch && (lifterSearchDO ? doMatch : true);
  });

  const handlePrint = (tableId, reportTitle) => {
    const printContent = document.getElementById(tableId).outerHTML;
    const printWindow = window.open("", "", "height=600,width=1000");
    printWindow.document.write(`
    <html>
      <head>
        <title>${reportTitle}</title>
        <style>
          table { width: 100%; border-collapse: collapse; font-size: 12px; }
          th, td { border: 1px solid #333; padding: 4px; text-align: center; }
          th { background: #f2f2f2; }
        </style>
      </head>
      <body>
        <h2 style="text-align:center;">${reportTitle}</h2>
        ${printContent}
      </body>
    </html>
  `);
    printWindow.document.close();
    printWindow.print();
  };

  return (
    <div
      style={{
        height: "calc(100vh - 8rem)",
        overflowY: "auto",
        padding: "0 1rem",
        backgroundColor: "#f5f5f5",
      }}
    >
      {/* Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-5 p-5">
        {(localStorage.getItem("user_type") === "Lifter"
          ? cardsDataLifetr
          : cardsData
        ).map((item, idx) => (
          <Card
            key={idx}
            style={{
              background: item.bg,
              borderRadius: "0",
              cursor: "pointer",
              minHeight: "4rem",
            }}
            onMouseMove={handleMouseMove}
            onMouseLeave={handleMouseLeave}
            onClick={() => navigate(item.link)}
          >
            <CardContent
              className="text-center"
              style={{ fontSize: "0.8rem", padding: "0.5rem" }}
            >
              <h3 className="text-gray-800 font-medium">{item.title}</h3>
              <p className="text-lg font-bold">{item.value}</p>
            </CardContent>
          </Card>
        ))}
      </div>

      {/* Scrollable content with search */}
      <div style={{ padding: "0 1rem" }}>
        {localStorage.getItem("user_type") !== "Lifter" && (
          <>
            <h1 style={{ textAlign: "center", fontSize: "20px" }}>
              PARTY DO STATUS
            </h1>
            <div className="flex gap-4 mb-4">
              <input
                type="text"
                placeholder="Search by Party Name"
                value={partySearchName}
                onChange={(e) => setPartySearchName(e.target.value)}
                className="border px-2 py-1 rounded w-1/2 text-sm"
              />
              <input
                type="text"
                placeholder="Search by DO Number"
                value={partySearchDO}
                onChange={(e) => setPartySearchDO(e.target.value)}
                className="border px-2 py-1 rounded w-1/2 text-sm"
              />
              <Button
                onClick={() => handlePrint("party-table", "Party DO Report")}
              >
                <FaFilePdf size={25} />
              </Button>
            </div>

            <div
              className="overflow-x-auto mb-4"
              style={{ maxHeight: "500px", overflowY: "auto" }}
            >
              <table className="border w-full" id="party-table">
                <thead
                  className="bg-gray-200 text-gray-700 sticky top-0 z-10"
                  style={{ fontSize: "0.8rem" }}
                >
                  <tr>
                    {[
                      "Sr. No.",
                      "Party Name",
                      "DO Number",
                      "Miles Name",
                      "Total Qty",
                      "Dispatch Qty",
                      "Balance Qty",
                    ].map((head, idx) => (
                      <th key={idx} className="border px-1 py-1">
                        {head}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody style={{ fontSize: "0.7rem" }}>
                  {filteredClientData.map((row, pIdx) => {
                    const partyTotal = row.client_pending_do.reduce(
                      (acc, b) => {
                        acc.totalQty += b.quantity;
                        acc.dispatchQty += b.dis_qty;
                        acc.balanceQty += b.rem_qty;
                        return acc;
                      },
                      { totalQty: 0, dispatchQty: 0, balanceQty: 0 }
                    );

                    return (
                      <React.Fragment key={pIdx}>
                        {row.client_pending_do.map((bill, bIdx) => (
                          <tr
                            key={bIdx}
                            className={`${
                              (pIdx + bIdx) % 2 === 0
                                ? "bg-gray-50"
                                : "bg-white"
                            }`}
                          >
                            {bIdx === 0 && (
                              <>
                                <td
                                  rowSpan={row.client_pending_do.length + 1}
                                  className="border px-1 py-1 text-center font-medium"
                                >
                                  {pIdx + 1}
                                </td>
                                <td
                                  rowSpan={row.client_pending_do.length + 1}
                                  className="border px-1 py-1"
                                >
                                  {row.client_name}
                                </td>
                              </>
                            )}
                            <td className="border px-1 py-1">{bill.do_no}</td>
                            <td className="border px-1 py-1">
                              {bill.mines_name}
                            </td>
                            <td className="border px-1 py-1 text-right">
                              {bill.quantity.toFixed(3)}
                            </td>
                            <td className="border px-1 py-1 text-right">
                              {bill.dis_qty.toFixed(3)}
                            </td>
                            <td className="border px-1 py-1 text-right">
                              {bill.rem_qty.toFixed(3)}
                            </td>
                          </tr>
                        ))}
                        <tr className="bg-blue-100 font-semibold">
                          <td
                            colSpan={2}
                            className="border px-1 py-1 text-right"
                          >
                            Total
                          </td>
                          <td className="border px-1 py-1 text-right">
                            {partyTotal.totalQty.toFixed(3)}
                          </td>
                          <td className="border px-1 py-1 text-right">
                            {partyTotal.dispatchQty.toFixed(3)}
                          </td>
                          <td className="border px-1 py-1 text-right">
                            {partyTotal.balanceQty.toFixed(3)}
                          </td>
                        </tr>
                      </React.Fragment>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </>
        )}

        {/* Second Table */}
        <h1 style={{ textAlign: "center", fontSize: "20px" }}>
          LIFTER DO STATUS
        </h1>
        <div className="flex gap-4 mb-4">
          <input
            type="text"
            placeholder="Search by Lifter Name"
            value={lifterSearchName}
            onChange={(e) => setLifterSearchName(e.target.value)}
            className="border px-2 py-1 rounded w-1/2 text-sm"
          />
          <input
            type="text"
            placeholder="Search by DO Number"
            value={lifterSearchDO}
            onChange={(e) => setLifterSearchDO(e.target.value)}
            className="border px-2 py-1 rounded w-1/2 text-sm"
          />
          <Button
            onClick={() => handlePrint("lifter-table", "Lifter DO Report")}
          >
            <FaFilePdf size={25} />
          </Button>
        </div>
        <div
          className="overflow-x-auto"
          style={{ maxHeight: "500px", overflowY: "auto" }}
        >
          <table className="border w-full" id="lifter-table">
            <thead
              className="bg-gray-200 text-gray-700 sticky top-0 z-10"
              style={{ fontSize: "0.8rem" }}
            >
              <tr>
                {[
                  "Sr. No.",
                  "Lifter Name",
                  "DO Number",
                  "Total Qty",
                  "Dispatch Qty",
                  "Balance Qty",
                  "Fate Rate",
                  "Shortage Rate",
                ].map((head, idx) => (
                  <th key={idx} className="border px-1 py-1">
                    {head}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody style={{ fontSize: "0.7rem" }}>
              {filteredLifterData.map((row, pIdx) => {
                const partyTotal = row.lifter_pending_dos.reduce(
                  (acc, b) => {
                    acc.totalQty += b.quantity;
                    acc.dispatchQty += b.dis_qty;
                    acc.balanceQty += b.rem_qty;
                    return acc;
                  },
                  { totalQty: 0, dispatchQty: 0, balanceQty: 0 }
                );

                return (
                  <React.Fragment key={pIdx}>
                    {row.lifter_pending_dos.map((bill, bIdx) => (
                      <tr
                        key={bIdx}
                        className={`${
                          (pIdx + bIdx) % 2 === 0 ? "bg-gray-50" : "bg-white"
                        }`}
                      >
                        {bIdx === 0 && (
                          <>
                            <td
                              rowSpan={row.lifter_pending_dos.length + 1}
                              className="border px-1 py-1 text-center font-medium"
                            >
                              {pIdx + 1}
                            </td>
                            <td
                              rowSpan={row.lifter_pending_dos.length + 1}
                              className="border px-1 py-1"
                            >
                              {row.name}
                            </td>
                          </>
                        )}
                        <td className="border px-1 py-1">{bill.do_no}</td>
                        <td className="border px-1 py-1 text-right">
                          {bill.quantity.toFixed(3)}
                        </td>
                        <td className="border px-1 py-1 text-right">
                          {bill.dis_qty.toFixed(3)}
                        </td>
                        <td className="border px-1 py-1 text-right">
                          {bill.rem_qty.toFixed(3)}
                        </td>
                        <td className="border px-1 py-1 text-right">
                          {bill.freight_rate || "-"}
                        </td>
                        <td className="border px-1 py-1 text-right">
                          {bill.shortage_rate || "-"}
                        </td>
                      </tr>
                    ))}
                    <tr className="bg-blue-100 font-semibold">
                      <td colSpan={1} className="border px-1 py-1 text-right">
                        Total
                      </td>
                      <td className="border px-1 py-1 text-right">
                        {partyTotal.totalQty.toFixed(3)}
                      </td>
                      <td className="border px-1 py-1 text-right">
                        {partyTotal.dispatchQty.toFixed(3)}
                      </td>
                      <td className="border px-1 py-1 text-right">
                        {partyTotal.balanceQty.toFixed(3)}
                      </td>
                      <td colSpan={2} className="border px-1 py-1"></td>
                    </tr>
                  </React.Fragment>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
